import anprCountriesData from './stati-esteri-anpr.json';

export interface AnprCountry {
  id: string;
  name: string;
  code: string;
}

/**
 * Codici del paese Italia secondo l'anagrafica ANPR: `code` è il codice
 * corrente, `legacyCode` quello storico ('IT').
 */
export const italyCountry = {
  code: '100',
  legacyCode: 'IT',
} as const;

/** Elenco completo dei paesi ANPR (Italia inclusa). */
export const anprCountries: AnprCountry[] = anprCountriesData;

/**
 * Normalizza un codice paese ANPR: i valori vuoti (anche di soli spazi) e il
 * codice legacy 'IT' vengono ricondotti al codice Italia corrente.
 */
export function normalizeCountryCode(code: string | null | undefined): string {
  const trimmed = code?.trim();
  if (!trimmed || trimmed === italyCountry.legacyCode) return italyCountry.code;

  return trimmed;
}

const countryNameByCode = new Map(
  anprCountries.map((country): [string, string] => [
    country.code,
    country.name,
  ]),
);

/**
 * Decodifica un codice paese ANPR nel nome del paese (es. '401' → 'ALGERIA').
 * Normalizza i codici legacy prima della ricerca. Ritorna null se il codice è
 * vuoto o non presente in anagrafica.
 */
export function getCountryName(code: string | null | undefined): string | null {
  const trimmed = code?.trim();
  if (!trimmed) return null;
  return countryNameByCode.get(normalizeCountryCode(trimmed)) ?? null;
}
